import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined; // GH var (D3); undefined in dev

export function initPostHog(): void {
  if (!import.meta.env.PROD || !POSTHOG_KEY) return; // never init in dev (§11 #7); mirror the Sentry gate
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com', // §6 — PostHog US cloud
    defaults: '2026-01-30', // modern snapshot: auto-sets capture_pageview:'history_change' (§6, §11 #3)
    person_profiles: 'identified_only', // §6 / spec §5
    session_recording: { maskAllInputs: true }, // NON-NEGOTIABLE mask on the SECOND SDK (§11 #4; AC-gated)
  });
}

// Re-export so <SentryPostHogIdentity/> (4.3, ADR 0016) imports posthog from the same singleton (no second init).
export { posthog };
